import PropTypes from "prop-types";

const FormikShape = PropTypes.shape({
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  isValid: PropTypes.bool.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
});

export default FormikShape;
